/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { InjectionToken } from '@angular/core';

export interface BuildInfo {
  date: string;
  version: string;
  pipelineRun: string;
}

export const BUILD_INFO = new InjectionToken<BuildInfo>('BUILD_INFO');
